import { observer } from "mobx-react";
import React from "react";
import { ValidatedValue } from "../../../helpers/validator";
import NumberInput from "../../sharedComponents/numberInput/numberInput";

interface YearProps {
  year: ValidatedValue<number>;
}

@observer
export default class Year extends React.Component<YearProps> {

  public render() {
    return (
      <div className={`${this.isLongErrorMessage() ? "field-container long-error" : "field-container"}`}>
        <div className="label">Rok budowy</div>
        <NumberInput className={"year"}
          validatedValue={this.props.year}
          topLabel={"Rok budowy"}
          maxLength={4}
        />
      </div>);
  }

  private isLongErrorMessage(): boolean {
    const numberOfErrorMessageCharacters = this.props.year.errorMessage!.length;
    const longErrorMinCharacters = 40;
    return numberOfErrorMessageCharacters > longErrorMinCharacters;
  }


}